// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"14e87325","405":"536595a4","453":"ace0a229"}[chunkId] + ".chunk.js";
};